<script setup lang="ts">
withDefaults(defineProps<{
  title?: string;
  goBackUrl?: string;
}>(), {
  title: '404 Not Found',
  goBackUrl: '',
});
</script>

<template>
  <div class="status-page-error">
    <div class="status-page-error-title">{{ title }}</div>
    <div class="tw:text-center">
      <div class="tw:my-4">
        <slot>
          The page you are trying to reach either <strong>does not exist</strong> or <strong>you are not authorized</strong> to view it.
        </slot>
      </div>
      <a v-if="goBackUrl" class="tw:block tw:my-4" :href="goBackUrl">Go Back</a>
    </div>
  </div>
</template>
